<template>
	<header>
		<nav class="navbar fixed-top navbar-expand-lg navbar-dark" :style="{ width: width + 'px' }"
			:class="{ scrolled: scrollPosition > 60 }">
			<router-link to="/" class="navbar-brand" @click="incrementCount()">
				<img src="@/style/img/logo-aeolus.png" alt="Aeolus Tyres" class="img-fluid" />
			</router-link>

			<button class="navbar-toggler" type="button" @click="changeTab()">
				<span class="navbar-toggler-icon"></span>
			</button>

			<div class="navbar-collapse" id="navbarSupportedContent" v-if="isShow">
				<ul class="navbar-nav ml-auto">
					<li class="nav-item dropdown" v-for="(item, index) in menu" :key="index"
						:class="{ active: num == index }">
						<router-link class="nav-link" :to="item.to" @click="navFun(item, index)">
							<span>{{ item.name }}</span>
						</router-link>

						<ul class="dropdown-menu" v-if="item.children">
							<li class="dropdown-item"
								:class="{ active: childnum == index1 && num == index, dropdownMobile: !isPC && itemChild.children }"
								v-for="(itemChild, index1) in item.children" :key="index1" style="position: relative;">

								<router-link :to="{ path: itemChild.to, query: { name: itemChild.children[1].name } }"
									class="nav-link" @click="navFun1(index, index1)"
									v-if="itemChild.name == '60th anniversary' && itemChild.children">
									<span>{{ itemChild.name }}</span>
								</router-link>

								<a href="https://www.aeolusotr.com/index.html" class="nav-link" target="_blank"
									v-else-if="itemChild.name == 'OTR'">
									<span>{{ itemChild.name }}</span>
								</a>


								<router-link :to="itemChild.to" class="nav-link" @click="navFun1(index, index1)" v-else>
									<span>{{ itemChild.name }}</span>
								</router-link>


								<ul class="dropdown-menu dropdown-menu2"
									:class="{ 'dropdown-menu3': itemChild.name == '60th anniversary' }"
									v-if="itemChild.children">
									<li class="dropdown-item" v-for="(itemChild1, index2) in itemChild.children"
										:key="index2"
										:class="{ active: childnum1 == index2 && childnum == index1 && num == index }">

										<router-link :to="{ path: itemChild1.to, query: { name: itemChild1.name } }"
											class="nav-link" @click="navFun2(index, index1, index2)"
											v-if="itemChild.name == '60th anniversary'">
											<span>{{ itemChild1.name }}</span>
										</router-link>

										<router-link :to="itemChild1.to" class="nav-link"
											@click="navFun2(index, index1, index2)" v-else>
											<span>{{ itemChild1.name }}</span>
										</router-link>

									</li>
								</ul>
							</li>


						</ul>

						<!-- <ul class="dropdown-menu dropdown-menu1" v-if="!isPC">
							<template v-for="(itemChild, index1) in item.children">
								<li class="dropdown-item" :class="{ 'active': childnum == index1 && num == index }"
									:key="index1" v-if="navIndex == index1" @click="navIndex = index1">
									<router-link :to="itemChild.to" class="nav-link" @click="navFun1(index, index1)">
										<span>{{ itemChild.name }}</span>
									</router-link>
								</li>
							</template>
</ul> -->
					</li>

					<!-- <li class="nav-item dropdown">
						<a class="nav-link" href="#"><span>Dealers</span></a>
					</li> -->
					<li class="nav-item dropdown">
						<a class="nav-link lang" href="#">EN</a>
						<ul class="dropdown-menu lang"></ul>
					</li>
				</ul>
			</div>
		</nav>
	</header>
	<router-view />

	<div class="bg-black">
		<footer>
			<div class="container">
				<div class="row align-items-center">
					<div class="col-12 col-sm-2 col-md-2 col-lg-3 py-3">
						<ul class="social">
							<li>
								<a href="https://www.linkedin.com/company/101899674/admin/feed/posts/"
									target="_blank"><i class="fab fa-linkedin-in"></i></a>
							</li>
							<li>
								<a href="https://www.facebook.com/profile.php?id=61556860914129" target="_blank"><i
										class="fab fa-facebook-f"></i></a>
							</li>
							<li>
								<a href="https://twitter.com/aeolus_official" target="_blank"><i
										class="fab fa-twitter"></i></a>
							</li>
						</ul>
					</div>
					<div class="col-12 col-sm-5 col-md-5 col-lg-6 py-3 borders">
						<ul class="links">
							<li>
								<p class="light">
									<router-link to="/dashboard/products/find" @click="incrementCount()">
										Find Your Tyre
									</router-link>
								</p>
							</li>
							<li>
								<p class="light">
									<router-link to="/dashboard/contact" @click="incrementCount()">
										Contact Us
									</router-link>
								</p>
							</li>
							<li>
								<p class="light">
									<router-link to="/dashboard/privacy-policy" @click="incrementCount()">
										Privacy Policy
									</router-link>
								</p>
							</li>
						</ul>
					</div>
					<div class="col-12 col-sm-5 col-md-5 col-lg-3 py-3">
						<p class="mb-2"><small>Subscribe to our Newsletter</small></p>
						<a name="nl"></a>
						<el-form ref="formRef" class="demo-dynamic" :model="dynamicValidateForm" :show-message="false">

							<div class="row">
								<div class="col-8">
									<el-form-item prop="email" :rules="[
										{
											required: true,
											message: 'Please input email address',
											trigger: 'blur',
										},
										{
											type: 'email',
											message: 'Please input correct email address',
											trigger: ['blur', 'change'],
										},
									]">
										<el-input v-model="dynamicValidateForm.email" placeholder="YOUR EMAIL" />
									</el-form-item>
									<!-- <input type="email" name="email_n" v-model="email" placeholder="YOUR EMAIL" /> -->
								</div>
								<div class="col-4 pl-0">
									<input type="button" value="SEND" @click="submitForm(formRef)" />
								</div>
							</div>


						</el-form>
						<!-- <form>
							<input type="hidden" name="jobs" value="0" />
							<div class="row">
								<div class="col-8">
									<input type="email" name="email_n" v-model="email" placeholder="YOUR EMAIL" />
								</div>
								<div class="col-4 pl-0">
									<input type="submit" value="SEND" @click="popup()" />
								</div>
							</div>

						</form> -->
					</div>
				</div>
				<div class="row mt-3">
					<div class="col-12 text-center">
						<p class="light">
							<small style="font-size: 70%">AEOLUS OFFICIAL WEBSITE | Copyright © 2025 AEOLUS TYRE Co.
								Ltd.
								| All rights reserved | Credits @ <a href=""></a></small>
						</p>
					</div>
				</div>
			</div>
		</footer>
	</div>
</template>
<script>
import {
	ElMessageBox,
	ElMessage
} from 'element-plus';

import {
	getTypeTheme,
	getTypeSustainability,
	contactus
} from '@/api/home'

import { mapGetters } from "vuex";
export default {
	data() {
		return {
			width: 990,
			navIndex: -1,
			isPC: true,
			isShow: true,
			scrollPosition: 0,
			menu: [
				{
					name: "About",
					to: "/dashboard/about/who-we-are",
					children: [
						{
							name: "Who We Are",
							to: "/dashboard/about/who-we-are",
						},
						{
							name: "History",
							to: "/dashboard/about/aeolus-history",
						},
					],
				},
				{
					name: "Products",
					to: "/dashboard/products/index",
					children: [
						{
							name: "Find Your Tyre",
							to: "/dashboard/products/find",
						},
						{
							name: "Truck & Bus",
							to: "/dashboard/products/truck-bus",
						},
						{
							name: "OTR",
							to: "/dashboard/coming",
						},
					],
				},
				{
					name: "Innovation",
					to: "/dashboard/innovation/technology",
					children: [
						{
							name: "Technology",
							to: "/dashboard/innovation/technology",
						},
						{
							name: "Sustainability",
							to: "/dashboard/innovation/sustainability",
							children: [
								{
									name: "Report",
									to: "/dashboard/innovation/report",
								},
								{
									name: "Regulations",
									to: "/dashboard/innovation/regulations",
								}
							],
						},
						{
							name: "Tyre Knowledge",
							to: "/dashboard/innovation/tyre-knowledge",
						},
						{
							name: "Services",
							to: "/dashboard/innovation/services",
						},
					],
				},
				{
					name: "Newsroom",
					to: "/dashboard/newsroom/index",
					children: [
						{
							name: "News Room",
							to: "/dashboard/newsroom/index",
						},
						{
							name: "60th anniversary",
							to: "/dashboard/newsroom/star-products",
						}
					]
					// children: [
					// 	{
					// 		name: "Star Products",
					// 		to: "/dashboard/newsroom/star-products",
					// 	},
					// 	{
					// 		name: "Glory Days",
					// 		to: "/dashboard/newsroom/glory-days",
					// 	},
					// 	{
					// 		name: "Anniversary Tribute",
					// 		to: "/dashboard/newsroom/anniversary-tribute",
					// 	},
					// 	{
					// 		name: "Voice of Aeolus Team",
					// 		to: "/dashboard/newsroom/voice-of-aeolus-team",
					// 	},
					// ],
				},

				//{
				// 	name: "Life at Aeolus",
				// 	to: "/dashboard/life-aeolus",
				// },

				{
					name: "Dealers",
					to: "/dashboard/coming"
				}

			],
			dynamicValidateForm: {
				email: ''
			}

		};
	},
	mounted() {
		this.getMobile();
		//监听滚动条滚动事件
		window.addEventListener("scroll", this.handleScroll, true);
		window.addEventListener("resize", this.handleResize, true);
		this.getTypeTheme();
		this.getTypeSustainability();
	},
	computed: {
		...mapGetters(["num", "childnum", "childnum1"]),
	},
	methods: {



		submitForm() {

			this.$refs.formRef.validate().then(valid => {

				this.getContactus()


			}).catch(errors => {
				ElMessageBox.alert('Please enter your email‌', 'Tips', {
					confirmButtonText: 'Confirm',
					callback: () => {

					}
				});
			})

		},

		async getContactus() {
			const data = await contactus({
				email: this.dynamicValidateForm.email,
				type: 2
			})
			this.dynamicValidateForm.email = '';

			ElMessage({
				message: 'Subscription successful',
				type: 'success',
			})


		},

		async getTypeSustainability() {
			const data = await getTypeSustainability()
			console.log(data)
		},
		async getTypeTheme() {
			const data = await getTypeTheme()

			if (data.code == 0) {
				if (data.data.length > 0) {
					let arr = data.data.map((item) => {
						let obj = {
							name: item.label,
							to: "/dashboard/newsroom/star-products",
							description: item.description
						}

						return obj
					})
					this.menu[3].children[1].children = arr;

					this.$store.commit("SET_THEMELIST", arr);
				}
			}
		},
		isMobile() {
			// 判断是否为移动设备
			return (
				typeof window.orientation !== "undefined" || // 判断是否存在window.orientation属性，此属性在移动设备上一般存在
				navigator.userAgent.indexOf("IEMobile") !== -1 || // 判断是否为Windows Phone
				navigator.userAgent.indexOf("iPhone") !== -1 || // 判断是否为iPhone
				(navigator.userAgent.indexOf("Android") !== -1 &&
					navigator.userAgent.indexOf("Mobile") !== -1) || // 判断是否为Android手机
				navigator.userAgent.indexOf("BlackBerry") !== -1 || // 判断是否为BlackBerry
				navigator.userAgent.indexOf("Opera Mini") !== -1 // 判断是否为Opera Mini浏览器
			);
		},
		getMobile() {
			if (this.isMobile()) {
				this.width = window.outerWidth;
				this.isShow = false;
				this.isPC = false;
			} else {
				// PC端
				let width = window.innerWidth;
				this.width = width;
				if (width < 992) {
					this.isShow = false;
					this.isPC = false;
				}
			}
		},
		handleResize() {
			let width = window.innerWidth;
			if (width < 992) {
				this.isShow = false;
			}
			this.width = width;
			console.log(width);
		},
		changeTab() {
			this.isShow = !this.isShow;
		},
		incrementCount() {
			this.$store.commit("SET_NUM", -1);
		},
		menuToActive() { },
		//滚动条改变触发该函数
		handleScroll() {
			const scrollTop = document.documentElement.scrollTop;
			this.scrollPosition = scrollTop;
		},
		navFun1(index, index1) {
			console.log('navFun1')
			this.$store.commit("SET_NUM", index);
			this.$store.commit("SET_CHILDNUM", index1);

			if (this.menu[index].children[index1].name == '60th anniversary') {
				this.$store.commit("SET_CHILDNUM1", 1);
			}

			if (this.menu[index].children[index1].name == 'Sustainability') {
				this.$store.commit("SET_CHILDNUM1", -1);
			}

			if (!this.isPC) {
				this.isShow = false;
			}
		},
		navFun2(index, index1, index2) {
			console.log('navFun2')
			this.$store.commit("SET_NUM", index);
			this.$store.commit("SET_CHILDNUM", index1);

			this.$store.commit("SET_CHILDNUM1", index2);

			if (this.menu[index].children[index1].name == '60th anniversary') {
				this.$store.commit("SET_THEMEITEM", this.menu[index].children[index1].children[index2]);
			}

			if (!this.isPC) {
				this.isShow = false;
			}
		},
		navFun(item, index) {
			console.log('navFun')
			if (!item.children) {
				this.$store.commit("SET_NUM", index);
				this.$store.commit("SET_CHILDNUM", -1);
				return;
			}
			if (item.to == item.children[0].to) {
				this.$store.commit("SET_NUM", index);
				this.$store.commit("SET_CHILDNUM", 0);
			} else {
				this.$store.commit("SET_NUM", index);
				this.$store.commit("SET_CHILDNUM", -1);
			}
			if (!this.isPC) {
				this.isShow = false;
			}
		},
	},
	beforeUnmount() {
		window.removeEventListener("scroll", this.handleScroll);
	},
};
</script>

<style lang="less">
.dropdown-menu1 {
	// display: inherit;
	// padding: 0;
}

.dropdown-menu2 {
	top: 0;
	left: 158px;
}

.dropdown-menu3 {
	top: 0;
	left: -170px;
}
</style>
